<template>
  <n-config-provider>
    <slot />
  </n-config-provider>
</template>
